import { motion } from 'framer-motion'
import { Loader2 } from 'lucide-react'
import ParticlesEffect from './particles/ParticleEffect'

export function AgentLoadingFallback() {
  return (
    <motion.div
      id="home-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="relative flex items-center flex-col min-h-screen justify-center z-10 overflow-hidden py-12 px-4 font-inter"
    >
      <Loader2 className="animate-spin" />
      <ParticlesEffect />
      <div className="bg-background-primary absolute inset-0 w-screen h-screen -z-10"></div>
    </motion.div>
  )
}
